import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { collection, getDocs, doc, deleteDoc } from 'firebase/firestore'
import { firestore } from '../../config/firebase'
import { deleteCreatedUser } from '../auth/helper'
// import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage'
// Initialize Firestore using the Firebase app

export const getAllUsers = createAsyncThunk('auth/getAllUsers', async () => {
  try {
    const usersCollection = collection(firestore, 'users') // Reference to 'users' collection
    const userSnapshot = await getDocs(usersCollection) // Get all documents
    const usersList = userSnapshot.docs.map((doc) => ({
      id: doc.id, // Document ID
      ...doc.data() // Spread document data
    }))
    return usersList // Return the list of users
  } catch (error) {
    console.log(error)
    throw new Error(error.message) // Handle any errors
  }
})

export const deleteUser = createAsyncThunk('auth/deleteUser', async (data) => {
  const { close, id } = data
  try {
    // Retrieve user document to get email and password
    const userRef = doc(firestore, 'users', id)
    const userSnap = await getDocs(collection(firestore, 'users'))
    let userData = null
    userSnap.forEach((docu) => {
      if (docu.id === id) {
        userData = docu.data()
      }
    })

    if (!userData) {
      throw new Error('User data not found')
    }

    // First delete the Firestore document
    await deleteDoc(userRef)

    // Then try to delete the Firebase Auth user
    if (userData.email && userData.password) {
      try {
        await deleteCreatedUser(userData.email, userData.password)
      } catch (error) {
        console.warn('Failed to delete Firebase Auth user:', error.message)
        // Continue even if Firebase Auth deletion fails
      }
    }

    return id
  } catch (error) {
    console.error('Error deleting user:', error)
    throw new Error(error.message)
  } finally {
    close && close()
  }
})

const usersSlice = createSlice({
  name: 'users',
  initialState: {
    users: [],
    loading: false,
    error: null
  },
  reducers: {
    manualAddNewUser: (state, action) => {
      if (action.payload) {
        const newUser = action.payload
        const prevState = [...state.users]
        const prevIndex = prevState.findIndex((el) => el?.id === newUser.id)
        if (prevIndex >= 0) {
          state.users[prevIndex] = newUser
          return
        }
        state.users = [...prevState, newUser]
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllUsers.pending, (state) => {
        state.loading = true
      })
      .addCase(getAllUsers.fulfilled, (state, action) => {
        state.users = action.payload
        state.loading = false
        state.error = false
      })
      .addCase(getAllUsers.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.users = state.users.filter(user => user.id !== action.payload)
      })
  }
})

export const { manualAddNewUser } = usersSlice.actions
export default usersSlice.reducer
